import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { ToggleButtonData } from './ToggleButtonData.model';

export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
    toggleButton: {}
  },
  emits: ["button-pressed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const toggleButtonModel = computed({
  get() {
    return props.toggleButton;
  },
  set(newValue: ToggleButtonData) {
    newValue.pressed = !newValue.pressed;
    emit('button-pressed', newValue);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    unelevated: "",
    "no-caps": "",
    modelValue: toggleButtonModel.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toggleButtonModel).value = $event)),
    label: _ctx.toggleButton.label,
    class: "iodine-toggle-button",
    disable: _ctx.toggleButton.disabled
  }, null, 8, ["modelValue", "label", "disable"]))
}
}

})